import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../components/Preloader';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  const [activeTab, setActiveTab] = useState('tab-mission');

  useEffect(() => {
    // Initialize scripts if needed
    if (window.initPathioScripts) {
      window.initPathioScripts();
    }
  }, []);

  return (
    <>
      <Preloader />
      <Sidebar />
      <Header />

      <main>

      <section className="ul-breadcrumb ul-section-spacing" style={{backgroundImage: "url('/assets/new-img/group-of-diversity-people-volunteen-arm-around-2025-02-10-01-27-31-utc.jpg')"}}>
        <div className="ul-container">
          <h2 className="ul-breadcrumb-title">About Us</h2>
          <ul className="ul-breadcrumb-nav">
            <li><Link to="/">Home</Link></li>
            <li>
              <span className="separator"><i className="flaticon-right"></i></span>
            </li>
            <li>About Us</li>
          </ul>
        </div>
      </section>

      <section className="ul-about ul-section-spacing wow animate__fadeInUp">
        <div className="ul-container">
          <div
            className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row"
          >
            <div className="col">
              <div className="ul-about-imgs">
                <div className="img-wrapper">
                  <img
                    src="/assets/new-img/young-happy-volunteers-outdoor-meeting-at-park-2025-03-18-17-25-46-utc.jpg"
                    alt="Image"
                  />
                </div>
                <div className="ul-about-imgs-vectors">
                  <img
                    src="/assets/img/about-img-vector-1.svg"
                    alt="Image"
                    className="vector-1"
                  />
                  <img
                    src="/assets/img/about-img-vector-2.svg"
                    alt="Image"
                    className="vector-2"
                  />
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-about-txt">
                <span className="ul-section-sub-title ul-section-sub-title--2"
                  >About PATHIO</span
                >
                <h2 className="ul-section-title">
                  A Student-Led Nonprofit Focused on Healthcare Pathways
                </h2>
                <p className="ul-section-descr">
                  Pathio is a student-led 501(c)(3) nonprofit providing peer-to-peer guidance and mentorship for students exploring healthcare careers, with a focus on Uzbek and Central Asian communities.
                  Through shared experiences, intentional mentorship, and community connection, we help students navigate complex academic and professional pathways
                </p>

                <div className="ul-about-block">
                  <div className="block-left">
                    <div className="block-heading">
                      <div className="icon"><i className="flaticon-love"></i></div>
                      <h3 className="block-title">Join Our Mission</h3>
                    </div>

                    <ul className="block-list">
                      <li>
                        Peer mentorship and student-to-student guidance
                      </li>
                      <li>Community conversations and storytelling</li>
                      <li>Resource navigation and referrals to trusted institutions</li>
                    </ul>
                  </div>
                  <div className="block-right">
                    <img
                      src="/assets/new-img/group-of-diversity-people-volunteen-arm-around-2025-02-10-01-27-31-utc.jpg"
                      alt="Image"
                    />
                  </div>
                </div>

                <div className="ul-about-bottom">
                  <Link to="/about" className="ul-btn"
                    ><i
                      className="flaticon-fast-forward-double-right-arrows-symbol"
                    ></i>
                    Explore More</Link
                  >

                  <div className="ul-about-call">
                    <div className="icon">
                      <i className="flaticon-email"></i>
                    </div>
                    <div className="txt">
                      <span className="call-title">Get Support</span>
                      <Link to="/contact">Contact Us</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="ul-about-vectors">
          <img
            src="/assets/img/about-vector-1.png"
            alt="vector"
            className="vector-1"
          />
        </div>
      </section>

      <section className="ul-about-tabs ul-events ul-section-spacing pt-0">
        <div className="ul-container">

          <div
            className="ul-section-heading align-items-center wow animate__fadeInUp"
            style={{paddingTop: 'clamp(80px, 4.21vw, 60px)'}}
          >
            <div className="left">
              <span className="ul-section-sub-title">Our Story</span>
              <h2 className="ul-section-title text-white">
                Mission, Vision & Values
              </h2>
            </div>
            <Link to="/donations" className="ul-btn"
              ><i className="flaticon-fast-forward-double-right-arrows-symbol"></i>
              Donate Now</Link
            >
          </div>

          <div className="tab-group">

            <div className="ul-about-tabs-wrapper">
              <div id="tab-mission" className={`ul-tab ul-about-tab ${activeTab === 'tab-mission' ? 'active' : ''}`}>
                <div className="ul-about-tab-img">
                  <img
                    src="/assets/new-img/teacher-explaining-the-work-of-solar-panel-to-stud-2025-02-11-18-50-44-utc.jpg"
                    alt="Image"
                  />
                </div>

                <div className="ul-about-tab-txt">
                  <h3 className="ul-about-tab-title">Our Mission</h3>
                  <p className="ul-about-tab-descr">
                    Pathio is a student-led 501(c)(3) nonprofit dedicated to providing clear, honest, and accessible guidance for students exploring healthcare careers.
                  </p>
                  <p className="ul-about-tab-descr">
                    We focus on peer-to-peer mentorship, education, and community support to help high school and undergraduate students bridge the gap between confusion and clarity in healthcare-related pathways. Through shared experiences and intentional mentorship, we aim to empower students—especially those from Uzbek/Central Asian communities—to make informed decisions and navigate their journeys with confidence.
                  </p>
                  <p className="ul-about-tab-descr">
                    Alongside student mentorship, Pathio focuses on raising awareness around general health topics and healthcare access within underserved communities. We create clear, science-based educational content and connect individuals to trusted, local healthcare resources, professional services, and official institutions, encouraging them to seek care and guidance from licensed professionals.
                  </p>
                </div>
              </div>

              <div id="tab-vision" className={`ul-tab ul-about-tab ${activeTab === 'tab-vision' ? 'active' : ''}`}>
                <div className="ul-about-tab-img">
                  <img
                    src="/assets/new-img/presenting-renewable-sources-of-energy-2025-03-17-06-37-43-utc.jpg"
                    alt="Image"
                  />
                </div>

                <div className="ul-about-tab-txt">
                  <h3 className="ul-about-tab-title">Our Vision</h3>
                  <p className="ul-about-tab-descr">
                    We picture a future where no student has to figure out healthcare on their own, where language barriers, cultural gaps, and lack of access don't determine who gets the information they need.
                  </p>
                  <p className="ul-about-tab-descr">
                    Pathio exists because too many students from Uzbek and Central Asian communities are left without guidance when it comes to healthcare pathways. We want to change that, not with generic advice, but through real conversations, shared experiences, and honest mentorship from people who've been in their shoes.
                  </p>
                  <p className="ul-about-tab-descr"><strong>What we stand for:</strong></p>
                  <div style={{marginTop: 'clamp(10px, 1.05vw, 16px)'}}>
                    <div style={{marginBottom: 'clamp(12px, 1.26vw, 18px)'}}>
                      <strong style={{whiteSpace: 'nowrap'}}>Clarity:</strong> Health info shouldn't be confusing. We break things down without dumbing them down.
                    </div>
                    <div style={{marginBottom: 'clamp(12px, 1.26vw, 18px)'}}>
                      <strong style={{whiteSpace: 'nowrap'}}>Accuracy:</strong> Everything we share is reviewed and backed by reliable sources.
                    </div>
                    <div style={{marginBottom: 'clamp(12px, 1.26vw, 18px)'}}>
                      <strong style={{whiteSpace: 'nowrap'}}>Equity:</strong> The communities that need this the most should be the first to receive it.
                    </div>
                    <div style={{marginBottom: 'clamp(12px, 1.26vw, 18px)'}}>
                      <strong style={{whiteSpace: 'nowrap'}}>Community:</strong> We build with our communities, not just for them.
                    </div>
                    <div style={{marginBottom: 'clamp(12px, 1.26vw, 18px)'}}>
                      <strong style={{whiteSpace: 'nowrap'}}>Empowerment:</strong> When people understand their options, they make better decisions.
                    </div>
                    <div>
                      <strong style={{whiteSpace: 'nowrap'}}>Student Leadership:</strong> Young people don't need to wait to make an impact. We're proof of that.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="tab-navs ul-about-tabs-nav">
              <button className={`tab-nav ${activeTab === 'tab-mission' ? 'active' : ''}`} onClick={() => setActiveTab('tab-mission')}>
                Our Mission
              </button>
              <button className={`tab-nav ${activeTab === 'tab-vision' ? 'active' : ''}`} onClick={() => setActiveTab('tab-vision')}>Our Vision</button>
            </div>
          </div>

        
        </div>
      </section>

      <section className="ul-team ul-section-spacing">
        <div className="ul-container">

          <div className="ul-section-heading justify-content-between">
            <div className="left">
              <span className="ul-section-sub-title">Our Team</span>
              <h2 className="ul-section-title">
                Meet Our Student Leaders
              </h2>
            </div>
            <div>
              <Link to="/team" className="ul-btn"
                ><i
                  className="flaticon-fast-forward-double-right-arrows-symbol"
                ></i>
                Get Involved</Link
              >
            </div>
          </div>

          <div
            className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 ul-team-row justify-content-center"
          >

            <div className="col">
              <div className="ul-team-member ul-team-member-no-bio">
                <div className="ul-team-member-front">
                  <div className="ul-team-member-img">
                    <img
                      src="/assets/team/doston.JPG"
                      alt="Doston - Team Member"
                    />
                  </div>
                  <div className="ul-team-member-info">
                    <h3 className="ul-team-member-name">
                      <Link to="/team">Doston Karimov</Link>
                    </h3>
                    <p className="ul-team-member-designation">Founder and President</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-team-member ul-team-member-no-bio">
                <div className="ul-team-member-front">
                  <div className="ul-team-member-img">
                    <img
                      src="/assets/team/zeeshan.JPG"
                      alt="Zeeshan - Team Member"
                    />
                    <div className="ul-team-member-socials">
                      <a href="https://www.linkedin.com/in/zeeshan-gondal/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="flaticon-linkedin-big-logo"></i></a>
                    </div>
                  </div>
                  <div className="ul-team-member-info">
                    <h3 className="ul-team-member-name">
                      <Link to="/team">Zeeshan Gondal</Link>
                    </h3>
                    <p className="ul-team-member-designation">Vice President</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-team-member ul-team-member-no-bio">
                <div className="ul-team-member-front">
                  <div className="ul-team-member-img">
                    <img
                      src="/assets/team/yulduz.JPG"
                      alt="Yulduz - Team Member"
                    />
                  </div>
                  <div className="ul-team-member-info">
                    <h3 className="ul-team-member-name">
                      <Link to="/team">Yulduz Mardonova</Link>
                    </h3>
                    <p className="ul-team-member-designation">Treasurer</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="ul-team-member ul-team-member-no-bio">
                <div className="ul-team-member-front">
                  <div className="ul-team-member-img">
                    <img
                      src="/assets/team/marjona.JPG"
                      alt="Marjona - Team Member"
                    />
                  </div>
                  <div className="ul-team-member-info">
                    <h3 className="ul-team-member-name">
                      <Link to="/team">Marjona Burhanova</Link>
                    </h3>
                    <p className="ul-team-member-designation">Secretary</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ul-cta" style={{position: 'relative'}}>
        <style>{`
          .ul-cta::before {
            display: none !important;
          }
          .ul-cta .ul-section-sub-title {
            color: var(--white) !important;
          }
          .ul-cta .ul-section-sub-title::before {
            background-color: var(--white) !important;
          }
          .ul-cta .ul-btn:hover {
            background-color: var(--ul-primary) !important;
            color: var(--white) !important;
            border-color: transparent !important;
            opacity: 0.9;
          }
          .ul-cta .ul-btn:hover i {
            background-color: var(--white) !important;
            color: var(--ul-primary) !important;
          }
          @media screen and (max-width: 991px) {
            .ul-footer-top {
              background: var(--ul-black) !important;
            }
          }
        `}</style>
        <div className="ul-container">
          <span className="ul-section-sub-title">Partner With Pathio</span>
          <h2 className="ul-cta-title">
            Navigating Healthcare — Together
          </h2>
          <Link to="/contact" className="ul-btn"
            ><i className="flaticon-fast-forward-double-right-arrows-symbol"></i>
            Get Involved</Link
          >
        </div>
        <img
          src="/assets/new-img/paper-cut-out-of-multi-coloured-hands-and-globe-wi-2025-04-05-04-46-26-utc.jpg"
          alt="Vector"
          className="ul-cta-vector"
        />
      </section>
    
      {/* <Testimonials /> */}
    </main>

      <Footer />
    </>
  );
};

export default About;
